var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2016_17732)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.3431 5 8.99998 6.34315 8.99998 8C8.99998 9.65685 10.3431 11 12 11C13.6568 11 15 9.65685 15 8C15 6.34315 13.6568 5 12 5ZM6.99998 8C6.99998 5.23858 9.23856 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23856 13 6.99998 10.7614 6.99998 8ZM7.04497 18.2759C5.96049 18.9809 5.3005 19.852 4.83203 20.5547C4.52568 21.0142 3.90481 21.1384 3.44528 20.8321C2.98576 20.5257 2.86158 19.9048 3.16793 19.4453C3.69946 18.648 4.53947 17.5191 5.955 16.5991C7.37982 15.6729 9.32214 15 12 15C14.6778 15 16.6201 15.6729 18.045 16.5991C19.4605 17.5191 20.3005 18.648 20.832 19.4453C21.1384 19.9048 21.0142 20.5257 20.5547 20.8321C20.0952 21.1384 19.4743 21.0142 19.1679 20.5547C18.6995 19.852 18.0395 18.9809 16.955 18.2759C15.8798 17.5771 14.3221 17 12 17C9.67783 17 8.12014 17.5771 7.04497 18.2759Z",
    fill: "#0864A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2016_17732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlue);
export default __webpack_public_path__ + "static/media/ProfileBlue.6de7149c988b4bcff31000677ce26206.svg";
export { ForwardRef as ReactComponent };